import { render } from "./AreaList.vue?vue&type=template&id=836f2f5a&scoped=true"
import script from "./AreaList.vue?vue&type=script&lang=js"
export * from "./AreaList.vue?vue&type=script&lang=js"

import "./AreaList.vue?vue&type=style&index=0&id=836f2f5a&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836f2f5a"]])

export default __exports__